module.exports = __webpack_public_path__ + "static/media/icon-google-calendar.0db3d1c5.svg";